// Log-scale slider mapping for fermentation duration: 1 minute -> 30 days on a
// 0..1000 integer range input, with snapping to common brewing durations.
export const DURATION_MIN_MINUTES = 1;
export const DURATION_MAX_MINUTES = 43200; // 30 days
// Duration the "skip to serving" preset writes into each fermentation step.
// 1 minute is the practical floor: the platform proto encodes step duration as
// uint32 minutes, so sub-minute can't be sent to a device.
export const SKIP_TO_SERVING_MINUTES = 1;
export const SLIDER_RANGE = 1000;
// 1m, 1h, 12h, 1d, 3d, 7d, 14d, 21d, 30d
export const SNAP_POINTS_MINUTES = [1, 60, 720, 1440, 4320, 10080, 20160, 30240, 43200];

const LOG_MAX = Math.log(DURATION_MAX_MINUTES);
// Snap radius: +-2% of total slider travel. In the log-compressed top end the
// 21d and 30d bands overlap slightly; .find() takes the first (lower) point.
const SNAP_TOLERANCE = SLIDER_RANGE * 0.02;

export function minutesToPosition(minutes) {
  const clamped = Math.min(DURATION_MAX_MINUTES, Math.max(DURATION_MIN_MINUTES, minutes));
  return Math.round((Math.log(clamped) / LOG_MAX) * SLIDER_RANGE);
}

export function positionToMinutes(position) {
  const snap = SNAP_POINTS_MINUTES.find(
    m => Math.abs(minutesToPosition(m) - position) <= SNAP_TOLERANCE
  );
  if (snap !== undefined) return snap;
  const raw = Math.exp((position / SLIDER_RANGE) * LOG_MAX);
  return Math.min(DURATION_MAX_MINUTES, Math.max(DURATION_MIN_MINUTES, Math.round(raw)));
}

export function formatDuration(minutes) {
  if (minutes < 60) return `${minutes} min`;
  if (minutes < 1440) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return m ? `${h} h ${m} min` : `${h} h`;
  }
  const d = Math.floor(minutes / 1440);
  const h = Math.floor((minutes % 1440) / 60);
  return h ? `${d} d ${h} h` : `${d} d`;
}
